import { reactive, toRefs } from 'vue'
import { instance } from '@cognitivecredit/ui-utils'
import { defineStore } from 'pinia'

export const useSurveyStore = defineStore('Survey', () => {
  const state = reactive({
    comment: '' as string,
    score: undefined as number | undefined,
    submitStatus: undefined as string | undefined,
    submissionAttempted: false as boolean,
    survey: {
      showPopup: false,
      showButton: false,
    },
  })

  const updateScore = (value: number) => {
    state.score = value
  }

  const updateComment = (value: string) => {
    state.comment = value
  }

  const handleError = (error?) => {
    state.submitStatus = 'error'
    console.error('Error submitting feedback', error)
  }

  const resetMessage = () => {
    state.submitStatus = undefined
  }

  const resetSurvey = () => {
    state.score = undefined
    state.comment = ''
    state.submitStatus = undefined
    state.submissionAttempted = false
  }

  const snoozeSurvey = async () => {
    try {
      const req = await instance({ prefix: 'user-management' })
      await req.put('/nps/snooze')
      await setSurvey()
    } catch (error) {
      console.error('Error snoozing nps survey:', error)
    }
  }

  const setSurvey = async () => {
    try {
      const req = await instance({ prefix: 'user-management' })
      const res = await req.get('/nps/survey')
      if (res.data) {
        state.survey = res.data
        return res.data
      }
      state.survey = { showPopup: false, showButton: false }
      return state.survey
    } catch (err) {
      console.error('[ERROR] Getting the user survey', err)
    }
  }

  const submitFeedback = async () => {
    if (state.score === undefined || state.submissionAttempted) {
      return
    }

    state.submissionAttempted = true

    const payload = {
      score: state.score,
      comment: state.comment,
    }

    try {
      const req = await instance({ prefix: 'user-management' })
      await req.post('/nps/survey', payload)
      state.submitStatus = 'success'
    } catch (error) {
      handleError(error)
    } finally {
      await setSurvey()
    }
  }
  return {
    ...toRefs(state),
    submitFeedback,
    updateScore,
    updateComment,
    setSurvey,
    snoozeSurvey,
    resetMessage,
    resetSurvey,
  }
})
